import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon, Tooltip } from '@ctct/ui-react';

const checkImg = <Icon glyph="check" />;
const minusImg = <Icon glyph="minus" />;

const renderTooltipContent = (feature) => {
  if (feature.tooltipLinkText && feature.tooltipLinkUrl) {
    return (
      <span>
        {feature.tooltipLabel}{' '}
        <a href={feature.tooltipLinkUrl} target="_blank" rel="noopener noreferrer">
          {feature.tooltipLinkText}
        </a>
      </span>
    );
  }

  return feature.tooltipLabel;
};

const ComparisonTableBody = ({ planFeatures, plans, recommendedPlanNameId }) => {
  return (
    <tbody className={classNames(plans.length === 3 && 'three-plans')}>
      {planFeatures.map((feature) => {
        if (feature.titleLabel) {
          return (
            <tr key={feature.titleLabel}>
              <td className="title-label" colSpan={plans.length + 1}>
                {feature.titleLabel}
              </td>
            </tr>
          );
        }

        return (
          <tr key={feature.label}>
            <td>
              <p>
                {feature.tooltipLabel ? (
                  <Tooltip content={renderTooltipContent(feature)} placement="above">
                    <span>{feature.label}</span>
                  </Tooltip>
                ) : (
                  <span>{feature.label}</span>
                )}
              </p>
            </td>

            {feature.fullrowLabel ? (
              <td colSpan={plans.length}>{feature.fullrowLabel}</td>
            ) : (
              plans.map((plan) => {
                const value = feature.plansDetails?.[plan.planNameId];

                if (value === undefined) {
                  return <React.Fragment key={plan.planId} />;
                }

                return (
                  <td
                    key={plan.planId}
                    className={classNames(recommendedPlanNameId === plan.planNameId && 'recommended')}
                  >
                    {typeof value === 'string' ? (
                      <p>{value}</p>
                    ) : (
                      <p className={classNames(value && 'checked')}>{value ? checkImg : minusImg}</p>
                    )}
                  </td>
                );
              })
            )}
          </tr>
        );
      })}
    </tbody>
  );
};

ComparisonTableBody.propTypes = {
  planFeatures: PropTypes.arrayOf(
    PropTypes.oneOf([
      PropTypes.shape({
        titleLabel: PropTypes.string.isRequired,
      }),
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        tooltipLabel: PropTypes.string,
        tooltipLinkText: PropTypes.string,
        tooltipLinkUrl: PropTypes.string,
        plansDetails: PropTypes.shape({
          // key should be the same as planNameId in plans
          lite: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          standard: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          premium: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

          email: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          emailPlus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          core: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          plus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        }),
        fullrowLabel: PropTypes.string,
      }),
    ])
  ).isRequired,
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      planId: PropTypes.number.isRequired,
      planNameId: PropTypes.string.isRequired,
    })
  ).isRequired,
  recommendedPlanNameId: PropTypes.string,
};

ComparisonTableBody.defaultProps = {
  recommendedPlanNameId: null,
};

export default ComparisonTableBody;
